
import "./polyfills";
import g from "./globals/variables";

import A11y from "./layout/a11y";
import Cookies from "./layout/cookies";
import Header from "./layout/header";
import Navigation from "./layout/navigation";
import Loader from "./layout/loader";
import Scroll from "./layout/scroll";

import Charts from "./components/charts";
import Accordion from "./components/accordion";
import Contact from "./components/contact";
import Details from "./components/details";
// import Filters from "./components/filters";
import { FormField } from "./components/form";
import Filter from "./components/filter";
import Hero from "./components/hero";
import HyphenText from "./components/hyphenText";
import Numbers from "./components/numbers";
import VideoModal from "./components/videoModal";

// layout

A11y.init();
Cookies.init();
new Contact(g.el.contactForm);
Loader.init();
Header.init();
Navigation.init();
new Filter(g.el.filters);
HyphenText.init();
Scroll.init();
VideoModal.init();

// components

g.el.details.forEach(target => new Details(target));
g.el.formFields.forEach(target => new FormField(target));
g.el.heroes.forEach(target => new Hero(target));
g.el.numbers.forEach(target => new Numbers(target));
g.el.accordions.forEach(target => new Accordion(target));
g.el.charts.forEach(target => new Charts(target));

// if (navigator.userAgent.match(/Trident.*rv:11\.|Edge/)) {
//   g.el.layout.classList.add("layout--ie");
// }
